import { N66 } from "./SalesSummaryPerProductGroup/N66"

export const ExecutiveRegionPerformanceByProductGroup = {
  "sections": [
    N66
  ]
}